<template>
  <div
    id="dashboard"
    class="dashboard_container"
  >
    <dashboard-dynamic />
  </div>
</template>

<script>
import DashboardContainer from './Container'
import { mapActions, mapGetters } from 'vuex'
import { removeCookie } from '../../utils/auth-utils'
import { toggleService } from '@/api/toggle'
import { SET_STATUS_MESSAGE, SET_PROFILE } from '../../store/types'

export default {
  name: 'Dashboard',
  components: {
    'dashboard-dynamic': DashboardContainer
  },
  methods: {
    ...mapActions(['getUserProfile']),
    clearDataLab() {
      removeCookie('refresh_token_aol')
      removeCookie('token_aol')
      removeCookie('token_portal')
      removeCookie('refresh_token_portal')
      removeCookie('profile')
      removeCookie('toggleAol')
      removeCookie('preferences')
      removeCookie('passwordChanged')
      toggleService.loaded = false
      this.$store.commit(SET_STATUS_MESSAGE, null)
      this.$store.commit(SET_PROFILE, null)
      window.location.reload()
    },
    checkProfileData() {
      if (this.profile === null) {
        this.getUserProfile()
      }

      let toggleConvertedInArray = Object.entries(this.toggle)
      let index = 0

      for (const [key, value] of toggleConvertedInArray) {
        index++
        if (value === true) {
          break
        } else {
          if (index === Object.entries(this.toggle).length) {
            this.clearDataLab()
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'toggle'])
  },
  created() {
    this.checkProfileData()
  }
}
</script>
